var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g4, _path38, _path39, _path40, _path41, _path42, _path43, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _path44, _path45, _path46, _path47, _path48, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 210,
    viewBox: "0 0 306 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 72.0883V65.7227L153 13.2227L277.312 65.7227V72.0883H28.6875Z",
    fill: "url(#paint0_linear_3588_7669)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 72.0883V65.7227L153 13.2227L277.312 65.7227V72.0883H28.6875Z",
    fill: "url(#paint1_linear_3588_7669)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 72.0883V65.7227L153 13.2227L277.312 65.7227V72.0883H28.6875Z",
    fill: "url(#paint2_linear_3588_7669)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 72.0883V65.7227L153 13.2227L277.312 65.7227V72.0883H28.6875Z",
    fill: "url(#paint3_radial_3588_7669)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 72.0883V65.7227L153 13.2227L277.312 65.7227V72.0883H28.6875Z",
    fill: "url(#paint4_linear_3588_7669)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.625 60.0137L139.804 15.7824C147.837 12.3043 158.164 12.3043 166.197 15.7824L269.376 60.0137V72.4168L159.407 25.5605C155.487 23.9199 150.61 23.9199 146.689 25.5605L36.7206 72.4168V60.0137H36.625Z",
    fill: "url(#paint5_linear_3588_7669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.625 60.0137L139.804 15.7824C147.837 12.3043 158.164 12.3043 166.197 15.7824L269.376 60.0137V72.4168L159.407 25.5605C155.487 23.9199 150.61 23.9199 146.689 25.5605L36.7206 72.4168V60.0137H36.625Z",
    fill: "url(#paint6_linear_3588_7669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.625 60.0137L139.804 15.7824C147.837 12.3043 158.164 12.3043 166.197 15.7824L269.376 60.0137V72.4168L159.407 25.5605C155.487 23.9199 150.61 23.9199 146.689 25.5605L36.7206 72.4168V60.0137H36.625Z",
    fill: "url(#paint7_radial_3588_7669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.625 60.0137L139.804 15.7824C147.837 12.3043 158.164 12.3043 166.197 15.7824L269.376 60.0137V72.4168L159.407 25.5605C155.487 23.9199 150.61 23.9199 146.689 25.5605L36.7206 72.4168V60.0137H36.625Z",
    fill: "url(#paint8_radial_3588_7669)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4355 61.0245L108.496 35.1289",
    stroke: "url(#paint9_linear_3588_7669)",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.646 16.8525L252.747 56.4244",
    stroke: "url(#paint10_linear_3588_7669)",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.625 65.8545H57.375V177.417H248.625V65.8545Z",
    fill: "#96919E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.625 65.8545H57.375V177.417H248.625V65.8545Z",
    fill: "url(#paint11_linear_3588_7669)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.625 65.8545H57.375V177.417H248.625V65.8545Z",
    fill: "url(#paint12_linear_3588_7669)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.625 65.8545H57.375V177.417H248.625V65.8545Z",
    fill: "url(#paint13_linear_3588_7669)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M267.75 89.8994H239.062V177.266H267.75V89.8994Z",
    fill: "url(#paint14_linear_3588_7669)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M267.75 89.8994H239.062V177.266H267.75V89.8994Z",
    fill: "url(#paint15_linear_3588_7669)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M267.75 89.8994H239.062V177.266H267.75V89.8994Z",
    fill: "url(#paint16_linear_3588_7669)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M267.75 89.8994H239.062V177.266H267.75V89.8994Z",
    fill: "url(#paint17_radial_3588_7669)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 90.0498H200.812V177.416H229.5V90.0498Z",
    fill: "url(#paint18_linear_3588_7669)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 90.0498H200.812V177.416H229.5V90.0498Z",
    fill: "url(#paint19_linear_3588_7669)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 90.0498H200.812V177.416H229.5V90.0498Z",
    fill: "url(#paint20_linear_3588_7669)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 90.0498H200.812V177.416H229.5V90.0498Z",
    fill: "url(#paint21_radial_3588_7669)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.188 90.0498H76.5V175.927H105.188V90.0498Z",
    fill: "url(#paint22_linear_3588_7669)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.188 90.0498H76.5V175.927H105.188V90.0498Z",
    fill: "url(#paint23_linear_3588_7669)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.188 90.0498H76.5V175.927H105.188V90.0498Z",
    fill: "url(#paint24_linear_3588_7669)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.188 90.0498H76.5V175.927H105.188V90.0498Z",
    fill: "url(#paint25_linear_3588_7669)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.188 90.0498H76.5V175.927H105.188V90.0498Z",
    fill: "url(#paint26_radial_3588_7669)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9375 90.0498H38.25V175.927H66.9375V90.0498Z",
    fill: "url(#paint27_linear_3588_7669)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9375 90.0498H38.25V175.927H66.9375V90.0498Z",
    fill: "url(#paint28_linear_3588_7669)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9375 90.0498H38.25V175.927H66.9375V90.0498Z",
    fill: "url(#paint29_linear_3588_7669)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9375 90.0498H38.25V175.927H66.9375V90.0498Z",
    fill: "url(#paint30_radial_3588_7669)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M277.303 89.8988V72.377H28.6777V89.8988H277.303Z",
    fill: "url(#paint31_linear_3588_7669)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.303 89.8988V72.377H28.6777V89.8988H277.303Z",
    fill: "url(#paint32_linear_3588_7669)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M277.303 89.8988V72.377H28.6777V89.8988H277.303Z",
    fill: "url(#paint33_linear_3588_7669)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M277.303 89.8988V72.377H28.6777V89.8988H277.303Z",
    fill: "url(#paint34_radial_3588_7669)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M277.303 89.8988V72.377H28.6777V89.8988H277.303Z",
    fill: "url(#paint35_linear_3588_7669)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M277.303 89.8988V72.377H28.6777V89.8988H277.303Z",
    fill: "url(#paint36_linear_3588_7669)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint37_linear_3588_7669)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint38_linear_3588_7669)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint39_linear_3588_7669)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint40_linear_3588_7669)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint41_radial_3588_7669)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint42_radial_3588_7669)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 65.8545C19.125 62.2451 23.4281 59.292 28.6875 59.292H277.312C282.572 59.292 286.875 62.2451 286.875 65.8545C286.875 69.4639 282.572 72.417 277.312 72.417H28.6875C23.4281 72.417 19.125 69.4639 19.125 65.8545Z",
    fill: "url(#paint43_radial_3588_7669)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 92.1045C19.125 88.4951 23.4281 85.542 28.6875 85.542H277.312C282.572 85.542 286.875 88.4951 286.875 92.1045C286.875 95.7139 282.572 98.667 277.312 98.667H28.6875C23.4281 98.667 19.125 95.7139 19.125 92.1045Z",
    fill: "url(#paint44_linear_3588_7669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 92.1045C19.125 88.4951 23.4281 85.542 28.6875 85.542H277.312C282.572 85.542 286.875 88.4951 286.875 92.1045C286.875 95.7139 282.572 98.667 277.312 98.667H28.6875C23.4281 98.667 19.125 95.7139 19.125 92.1045Z",
    fill: "url(#paint45_linear_3588_7669)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 92.1045C19.125 88.4951 23.4281 85.542 28.6875 85.542H277.312C282.572 85.542 286.875 88.4951 286.875 92.1045C286.875 95.7139 282.572 98.667 277.312 98.667H28.6875C23.4281 98.667 19.125 95.7139 19.125 92.1045Z",
    fill: "url(#paint46_linear_3588_7669)"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 92.1045C19.125 88.4951 23.4281 85.542 28.6875 85.542H277.312C282.572 85.542 286.875 88.4951 286.875 92.1045C286.875 95.7139 282.572 98.667 277.312 98.667H28.6875C23.4281 98.667 19.125 95.7139 19.125 92.1045Z",
    fill: "url(#paint47_radial_3588_7669)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 92.1045C19.125 88.4951 23.4281 85.542 28.6875 85.542H277.312C282.572 85.542 286.875 88.4951 286.875 92.1045C286.875 95.7139 282.572 98.667 277.312 98.667H28.6875C23.4281 98.667 19.125 95.7139 19.125 92.1045Z",
    fill: "url(#paint48_radial_3588_7669)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M286.875 190.542H19.125V184.439C19.125 180.567 23.715 177.417 29.3569 177.417H276.548C282.189 177.417 286.779 180.567 286.779 184.439V190.542H286.875Z",
    fill: "url(#paint49_linear_3588_7669)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M286.875 190.542H19.125V184.439C19.125 180.567 23.715 177.417 29.3569 177.417H276.548C282.189 177.417 286.779 180.567 286.779 184.439V190.542H286.875Z",
    fill: "url(#paint50_linear_3588_7669)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M286.875 190.542H19.125V184.439C19.125 180.567 23.715 177.417 29.3569 177.417H276.548C282.189 177.417 286.779 180.567 286.779 184.439V190.542H286.875Z",
    fill: "url(#paint51_linear_3588_7669)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M286.875 190.542H19.125V184.439C19.125 180.567 23.715 177.417 29.3569 177.417H276.548C282.189 177.417 286.779 180.567 286.779 184.439V190.542H286.875Z",
    fill: "url(#paint52_linear_3588_7669)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.688 164.292H124.312V122.489C124.312 120.192 126.99 118.354 130.337 118.354H175.568C178.914 118.354 181.688 120.258 181.688 122.554V164.292Z",
    fill: "#4B4258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.688 164.292H124.312V122.489C124.312 120.192 126.99 118.354 130.337 118.354H175.568C178.914 118.354 181.688 120.258 181.688 122.554V164.292Z",
    fill: "url(#paint53_linear_3588_7669)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.809 85.5414C165.515 85.5414 177.7 82.0775 186.685 75.9116C195.669 69.7458 200.717 61.3831 200.717 52.6633C200.717 43.9435 195.669 35.5808 186.685 29.4149C177.7 23.2491 165.515 19.7852 152.809 19.7852C140.102 19.7852 127.917 23.2491 118.932 29.4149C109.948 35.5808 104.9 43.9435 104.9 52.6633C104.9 61.3831 109.948 69.7458 118.932 75.9116C127.917 82.0775 140.102 85.5414 152.809 85.5414Z",
    fill: "#B2ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.809 85.5414C165.515 85.5414 177.7 82.0775 186.685 75.9116C195.669 69.7458 200.717 61.3831 200.717 52.6633C200.717 43.9435 195.669 35.5808 186.685 29.4149C177.7 23.2491 165.515 19.7852 152.809 19.7852C140.102 19.7852 127.917 23.2491 118.932 29.4149C109.948 35.5808 104.9 43.9435 104.9 52.6633C104.9 61.3831 109.948 69.7458 118.932 75.9116C127.917 82.0775 140.102 85.5414 152.809 85.5414Z",
    fill: "url(#paint54_radial_3588_7669)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.24 58.7734C165.227 60.414 164.497 61.8556 163.05 63.0981C161.712 64.2793 159.904 65.1981 157.705 65.7887C157.131 65.9812 156.557 66.1103 155.984 66.1759V69.9756C155.984 71.5506 153.784 72.8565 151.394 72.8565C149.003 72.8565 146.737 71.544 146.737 69.969V66.4384C145.319 66.3091 143.935 66.044 142.625 65.6509C139.957 64.9946 137.767 63.8134 136.046 62.245C135.494 61.7098 135.224 61.0618 135.281 60.4075C135.281 59.364 135.95 58.5109 137.384 57.789C139.393 56.9359 141.582 57.1328 143.39 58.3796C144.442 59.1671 145.589 59.7578 146.737 60.1515C146.832 60.2172 147.024 60.2171 147.119 60.2828C148.458 60.6765 150.074 60.939 151.891 60.939C155.993 60.8078 155.993 59.4953 155.993 58.9703C155.993 58.3797 155.611 57.9203 154.75 57.5921C153.698 57.1984 151.881 56.739 149.596 56.3453C148.544 56.1528 147.588 55.9581 146.727 55.7612C145.388 55.4331 144.155 55.1706 143.199 54.8425C141.382 54.3175 139.861 53.53 138.618 52.4209C137.279 51.3053 136.61 49.8615 136.61 48.0306C136.61 46.39 137.279 45.0184 138.714 43.7781C139.957 42.5968 141.678 41.7437 143.877 41.0875C144.824 40.825 145.78 40.5625 146.737 40.4312V36.5068C146.737 34.9318 148.821 33.5537 151.202 33.5537C153.583 33.5537 155.984 34.9318 155.984 36.5068V40.7003C156.557 40.7659 157.035 40.8971 157.609 41.0284C160 41.6846 162.008 42.5968 163.347 43.8437C164.112 44.4343 164.399 45.1562 164.399 45.8715C164.399 46.7903 163.92 47.5778 162.773 48.1684C161.919 48.6357 160.846 48.8734 159.754 48.8372C158.663 48.801 157.629 48.4932 156.844 47.9715C156.573 47.7848 156.286 47.6095 155.984 47.4465C155.458 47.0613 154.806 46.7687 154.081 46.5934C152.888 46.2054 151.574 46.0251 150.256 46.0684C148.161 46.0684 147.215 46.3965 146.737 46.7903C146.354 47.1184 146.354 47.5122 146.354 47.7747C146.354 48.1028 146.45 48.4309 146.737 48.6934C146.737 48.759 146.832 48.8246 146.928 48.8903C147.502 49.2118 148.075 49.4743 148.936 49.6712C149.787 49.8681 151.126 50.1306 152.837 50.4587C153.985 50.7212 155.037 50.9181 155.993 51.115C157.141 51.3775 158.097 51.64 158.957 51.9025C160.669 52.4931 162.19 53.274 163.337 54.3831C164.58 55.4987 165.25 56.9425 165.25 58.78",
    fill: "#6A6177"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.77 58.2422C166.77 59.8828 166.005 61.3266 164.571 62.5734C163.174 63.7868 161.323 64.7168 159.216 65.2641C158.642 65.4609 158.068 65.5922 157.494 65.6578V69.4641C157.494 71.0391 155.276 72.3516 152.885 72.3516C150.495 72.3516 148.219 71.0391 148.219 69.4641V65.9203C146.801 65.791 145.417 65.5259 144.107 65.1328C141.429 64.4766 139.23 63.2953 137.509 61.7203C136.957 61.1852 136.687 60.5371 136.744 59.8828C136.744 58.8328 137.413 57.9797 138.847 57.2578C140.856 56.4047 143.055 56.6016 144.872 57.8484C145.924 58.6359 147.071 59.2266 148.219 59.6203C148.314 59.6859 148.506 59.6859 148.601 59.7516C149.94 60.1453 151.566 60.4078 153.382 60.4078C157.494 60.2766 157.494 58.9641 157.494 58.4391C157.494 57.8484 157.112 57.3891 156.251 57.0609C155.199 56.6672 153.382 56.2078 151.087 55.8141C150.036 55.6172 149.079 55.4203 148.219 55.2234C146.88 54.8953 145.637 54.6328 144.681 54.3047C142.864 53.7797 141.334 52.9922 140.091 51.8766C138.752 50.7609 138.082 49.3172 138.082 47.4797C138.082 45.8391 138.752 44.4609 140.186 43.2141C141.429 42.0328 143.151 41.1797 145.35 40.5234C146.306 40.2609 147.262 39.9984 148.219 39.8672V35.9297C148.219 34.3547 150.313 32.9766 152.703 32.9766C155.094 32.9766 157.494 34.3547 157.494 35.9297V40.1297C158.068 40.1953 158.546 40.3266 159.12 40.4578C161.511 41.1141 163.519 42.0328 164.857 43.2797C165.622 43.8703 165.909 44.5922 165.909 45.3141C165.909 46.2328 165.431 47.0203 164.284 47.6109C162.562 48.5953 159.885 48.4641 158.355 47.4141C158.084 47.2274 157.796 47.052 157.494 46.8891C156.966 46.503 156.31 46.2103 155.582 46.0359C154.389 45.6479 153.075 45.4676 151.757 45.5109C149.653 45.5109 148.697 45.8391 148.219 46.2328C147.836 46.5609 147.836 46.9547 147.836 47.2172C147.836 47.5453 147.932 47.8734 148.219 48.1359C148.219 48.2016 148.314 48.2672 148.41 48.3328C148.984 48.6609 149.557 48.9234 150.418 49.1203C151.279 49.3172 152.617 49.5797 154.339 49.9078C155.486 50.1703 156.538 50.3672 157.494 50.5641C158.642 50.8266 159.598 51.0891 160.459 51.3516C162.18 51.9422 163.71 52.7297 164.857 53.8453C166.101 54.9609 166.77 56.4047 166.77 58.2422Z",
    fill: "#734B9B"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.817 45.0184C159.378 43.5091 154.941 41.2187 148.525 42.4984C141.63 43.8766 141.869 49.9797 147.77 51.3709C157.332 53.6284 161.817 53.2675 162.716 57.2641C163.605 61.2672 158.001 62.8553 152.484 62.5469C147.636 62.2778 143.093 60.0662 141.793 58.9047",
    stroke: "#8E66B8",
    strokeWidth: 0.075,
    strokeLinecap: "round"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.559 35.2793V42.6555",
    stroke: "#8E66B8",
    strokeWidth: 0.075,
    strokeLinecap: "round"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.252 62.9473V69.2998",
    stroke: "#8E66B8",
    strokeWidth: 0.075,
    strokeLinecap: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3047 98.667H62.2607V167.632H54.3047V98.667Z",
    fill: "url(#paint55_linear_3588_7669)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.156 98.667H223.112V167.632H215.156V98.667Z",
    fill: "url(#paint56_linear_3588_7669)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_3588_7669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6465 98.667H99.6025V167.632H91.6465V98.667Z",
    fill: "url(#paint57_linear_3588_7669)"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.312 177.417H28.4004V171.314C28.4004 167.442 32.9904 164.292 38.6323 164.292H267.08C272.722 164.292 277.312 167.442 277.312 171.314V177.417Z",
    fill: "url(#paint58_linear_3588_7669)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M277.312 177.417H28.4004V171.314C28.4004 167.442 32.9904 164.292 38.6323 164.292H267.08C272.722 164.292 277.312 167.442 277.312 171.314V177.417Z",
    fill: "url(#paint59_linear_3588_7669)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M277.312 177.417H28.4004V171.314C28.4004 167.442 32.9904 164.292 38.6323 164.292H267.08C272.722 164.292 277.312 167.442 277.312 171.314V177.417Z",
    fill: "url(#paint60_linear_3588_7669)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M277.312 177.417H28.4004V171.314C28.4004 167.442 32.9904 164.292 38.6323 164.292H267.08C272.722 164.292 277.312 167.442 277.312 171.314V177.417Z",
    fill: "url(#paint61_linear_3588_7669)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M277.312 177.417H28.4004V171.314C28.4004 167.442 32.9904 164.292 38.6323 164.292H267.08C272.722 164.292 277.312 167.442 277.312 171.314V177.417Z",
    fill: "url(#paint62_linear_3588_7669)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3588_7669",
    x: 36.625,
    y: 13.0238,
    width: 232.752,
    height: 59.3932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.352941 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3588_7669",
    x: 46.0605,
    y: 34.7539,
    width: 62.8105,
    height: 26.6455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3588_7669",
    x: 159.271,
    y: 16.4775,
    width: 93.8496,
    height: 40.3223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3588_7669",
    x: 19.125,
    y: 85.542,
    width: 267.95,
    height: 13.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.486275 0 0 0 0 0.521569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3588_7669",
    x: 124.138,
    y: 118.354,
    width: 57.55,
    height: 46.1125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.175,
    dy: 0.175
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.0784314 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_3588_7669",
    x: 104.75,
    y: 19.6352,
    width: 96.1164,
    height: 66.0559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.878431 0 0 0 0 0.937255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3588_7669"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.423529 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3588_7669",
    result: "effect2_innerShadow_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3588_7669",
    x: 135.123,
    y: 33.4037,
    width: 30.2766,
    height: 39.6027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_3588_7669",
    x: 136.736,
    y: 32.8516,
    width: 30.1582,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.125,
    dy: -0.125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.207843 0 0 0 0 0.47451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3588_7669",
    x: 141.606,
    y: 41.9369,
    width: 21.3918,
    height: 20.8352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_3588_7669",
    x: 154.371,
    y: 35.0922,
    width: 0.374219,
    height: 7.75117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_3588_7669",
    x: 154.065,
    y: 62.7602,
    width: 0.374219,
    height: 6.72676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_3588_7669",
    x: 53.9297,
    y: 98.292,
    width: 8.70508,
    height: 69.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3588_7669",
    x: 214.781,
    y: 98.292,
    width: 8.70508,
    height: 69.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_3588_7669",
    x: 91.2715,
    y: 98.292,
    width: 8.70508,
    height: 69.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875,
    result: "effect1_foregroundBlur_3588_7669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3588_7669",
    x1: 213.368,
    y1: 54.1923,
    x2: 90.8438,
    y2: 54.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E98A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#847E89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3588_7669",
    x1: 210.021,
    y1: 44.5192,
    x2: 207.557,
    y2: 50.2743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56525D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3588_7669",
    x1: 98.0156,
    y1: 43.5939,
    x2: 99.773,
    y2: 47.8848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56525D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.064 54.1661) rotate(177.193) scale(23.4543 33.9587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    stopColor: "#605D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605D64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3588_7669",
    x1: 179.048,
    y1: 63.918,
    x2: 179.048,
    y2: 58.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6870",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3588_7669",
    x1: 61.9082,
    y1: 42.7937,
    x2: 271.91,
    y2: 42.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3588_7669",
    x1: 217.308,
    y1: 36.8349,
    x2: 213.816,
    y2: 45.0122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD2E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.001 23.3227) rotate(90) scale(7.69046 16.6654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D797E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E97A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.852 48.0017) rotate(-149.042) scale(23.8777 24.8684)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#605C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605C64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3588_7669",
    x1: 46.4355,
    y1: 61.0245,
    x2: 94.5836,
    y2: 15.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2AAB8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3588_7669",
    x1: 159.646,
    y1: 16.8525,
    x2: 231.75,
    y2: 84.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD3E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DDD3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#DDD3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDD3E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3588_7669",
    x1: 225.914,
    y1: 150.576,
    x2: 185.876,
    y2: 150.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#56525D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55505C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3588_7669",
    x1: 67.8364,
    y1: 150.576,
    x2: 110.963,
    y2: 150.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3588_7669",
    x1: 185.876,
    y1: 95.6154,
    x2: 185.876,
    y2: 112.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645A6D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3588_7669",
    x1: 239.062,
    y1: 133.566,
    x2: 264.164,
    y2: 133.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3588_7669",
    x1: 235.802,
    y1: 129.753,
    x2: 248.501,
    y2: 129.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3588_7669",
    x1: 271.106,
    y1: 127.529,
    x2: 253.406,
    y2: 127.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DBEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.088 155.459) rotate(-90) scale(62.0569 61.507)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3588_7669",
    x1: 200.812,
    y1: 133.717,
    x2: 225.914,
    y2: 133.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E99A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3588_7669",
    x1: 197.552,
    y1: 129.91,
    x2: 210.251,
    y2: 129.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3588_7669",
    x1: 232.856,
    y1: 127.686,
    x2: 222.94,
    y2: 127.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.838 155.609) rotate(-90) scale(62.0569 36.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3588_7669",
    x1: 65.3214,
    y1: 132.975,
    x2: 94.0089,
    y2: 132.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3588_7669",
    x1: 76.5,
    y1: 132.975,
    x2: 101.602,
    y2: 132.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3588_7669",
    x1: 73.2296,
    y1: 129.228,
    x2: 85.9382,
    y2: 129.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3588_7669",
    x1: 108.544,
    y1: 127.043,
    x2: 94.9078,
    y2: 127.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B1BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.5253 154.494) rotate(-90) scale(60.9983 36.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3588_7669",
    x1: 38.25,
    y1: 132.975,
    x2: 63.3516,
    y2: 132.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E99A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3588_7669",
    x1: 34.9796,
    y1: 129.228,
    x2: 47.6882,
    y2: 129.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76727B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3588_7669",
    x1: 70.2939,
    y1: 127.043,
    x2: 60.3776,
    y2: 127.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2753 154.494) rotate(-90) scale(60.9983 36.237)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#655E71",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#655E71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3588_7669",
    x1: 59.8419,
    y1: 78.3948,
    x2: 277.303,
    y2: 78.3948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA8B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3588_7669",
    x1: 152.99,
    y1: 72.377,
    x2: 152.99,
    y2: 75.0873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676071",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3588_7669",
    x1: 26.6122,
    y1: 79.5038,
    x2: 40.7552,
    y2: 79.5038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7881",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.892 72.3783) rotate(138.921) scale(21.0107 43.1545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#645D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#645D6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3588_7669",
    x1: 178.704,
    y1: 89.8988,
    x2: 178.704,
    y2: 83.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D5A61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3588_7669",
    x1: 277.303,
    y1: 81.1379,
    x2: 269.461,
    y2: 81.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD2E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3588_7669",
    x1: 152.981,
    y1: 59.2789,
    x2: 152.981,
    y2: 72.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3588_7669",
    x1: 47.2196,
    y1: 72.417,
    x2: 153,
    y2: 72.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A8B4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3588_7669",
    x1: 141.946,
    y1: 74.0839,
    x2: 141.946,
    y2: 65.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7586",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3588_7669",
    x1: 19.125,
    y1: 65.8545,
    x2: 30.9251,
    y2: 65.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7586",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.962 61.0639) rotate(160.898) scale(14.634 30.0833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#685F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685F73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.254 52.0601) rotate(96.1602) scale(17.4722 133.655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.46 61.3067) rotate(-28.4486) scale(10.1295 7.86391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3588_7669",
    x1: 152.981,
    y1: 85.5289,
    x2: 152.981,
    y2: 98.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#948B9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3588_7669",
    x1: 16.0841,
    y1: 98.667,
    x2: 29.2134,
    y2: 98.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79747E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79747E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3588_7669",
    x1: 141.774,
    y1: 102.591,
    x2: 141.774,
    y2: 93.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787182",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.88 77.4701) rotate(90) scale(13.9453 37.6957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#4E4B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6A72",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.46 87.5567) rotate(-28.4486) scale(10.1295 7.86391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EBFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3588_7669",
    x1: 141.869,
    y1: 177.417,
    x2: 141.869,
    y2: 190.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3588_7669",
    x1: 153,
    y1: 174.641,
    x2: 153,
    y2: 185.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3588_7669",
    x1: 17.9392,
    y1: 190.542,
    x2: 31.4128,
    y2: 190.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79737C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79737C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3588_7669",
    x1: 292.326,
    y1: 183.979,
    x2: 273.669,
    y2: 183.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3588_7669",
    x1: 124.312,
    y1: 152.873,
    x2: 135.137,
    y2: 152.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4461",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3588_7669",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.843 58.307) rotate(-25.8161) scale(62.0643 51.6665)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#EBE1F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3588_7669",
    x1: 58.2827,
    y1: 157.887,
    x2: 58.2827,
    y2: 71.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3588_7669",
    x1: 219.134,
    y1: 157.887,
    x2: 219.134,
    y2: 71.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3588_7669",
    x1: 95.6245,
    y1: 157.887,
    x2: 95.6245,
    y2: 71.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#CEC5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC5D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3588_7669",
    x1: 142.51,
    y1: 164.292,
    x2: 142.51,
    y2: 177.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0B9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB8C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3588_7669",
    x1: 152.856,
    y1: 161.516,
    x2: 152.856,
    y2: 172.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#CBC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC3D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3588_7669",
    x1: 27.3007,
    y1: 177.417,
    x2: 39.8276,
    y2: 177.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79737C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79737C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3588_7669",
    x1: 282.38,
    y1: 170.854,
    x2: 265.034,
    y2: 170.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3588_7669",
    x1: 152.856,
    y1: 180.311,
    x2: 152.856,
    y2: 176.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#817B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817B84",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.225953574130f98023be59cadfd3cc00.svg";
export { ForwardRef as ReactComponent };